export default __webpack_public_path__ + "locales/ko-KR/SharingPanel.json?hash=d5ca5cebfa865cadc1f5c5c2d0a473bd";